<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="ArchiveBulkPaymentsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('deposit.lump_sum_deposit')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="defaultCheck1" @click="checkDetails()" v-model="allChecked">
                    <label class="form-check-label" for="defaultCheck1">
                      {{translations('invoice.choice')}}
                    </label>
                  </div>
                </th>
                <th>{{translations('invoice.payment_day')}}</th>
                <th>{{translations('invoice.customer_name')}}</th>
                <th>{{translations('invoice.billing_amount')}}</th>
                <th>{{translations('invoice.deposit_amount')}}</th>
                <th>{{translations('invoice.transfer_fee')}}</th>
                <th>{{translations('invoice.remaining_amount')}}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <template v-for="(detail, i) in tempDetails">
              <tr :key="i">
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="detail.isChecked">
                    <label class="form-check-label" for="defaultCheck1">
                    </label>
                  </div>
                </td>
                <td><input type="date" class="form-control" v-model="detail.paid_at"></td>
                <td class="">{{detail.client_name /* + ' （' + $invoiceTools.formatDateAt(detail.billed_at) + '）' */ }}</td>
                <td class="right">{{Number(detail.total_amount).toLocaleString()}}</td>
                <td><input type="text" class="form-control" v-model="detail.paid"></td>
                <td><input type="text" class="form-control" v-model="detail.transfer_fee"></td>
                <td class="right">{{Number(detail.remaining_price).toLocaleString()}}</td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="updateBilling()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import 'date-utils'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveBulkPaymentsModal',
  components: {
    VueElementLoading
  },
  props: {
    isOpen: Boolean
  },
  data () {
    return {
      tempDetails: [],
      allChecked: false,
      isSearching: true
    }
  },
  watch: {
    tempDetails: {
      handler: function (data) {
        console.log(data)
        let hasAllChecked = true
        data.forEach(function (detail) {
          if (!detail.isChecked) {
            hasAllChecked = false
          }

          detail.remaining_price = Number(detail.sub_total) - (Number(detail.paid) + Number(detail.transfer_fee))
        })

        this.allChecked = hasAllChecked
      },
      deep: true
    }
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.listBillingList)
    window.$(this.$refs.vuemodal).on('hidden.bs.modal', this.clearDetails)
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    clearDetails () {
      this.tempDetails = []
    },
    checkDetails () {
      let hasOneChecked = false
      let hasAllChecked = true
      this.tempDetails.forEach(function (detail) {
        if (detail.isChecked) {
          hasOneChecked = true
        } else {
          hasAllChecked = false
        }
      })

      if (hasAllChecked) {
        hasOneChecked = false
      } else if (hasAllChecked === false && hasOneChecked === false) {
        hasOneChecked = true
      }

      this.tempDetails.forEach(function (detail) {
        detail.isChecked = hasOneChecked
      })
    },

    async listBillingList () {
      this.isSearching = true
      try {
        const cList = await this.$http.post(this.$api_url.billing_billed_list)

        const $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'ArchiveBulkPaymentsModal:listBillingList')
        if ($data.success === true) {
          this.tempDetails = $data.data
          this.tempDetails.forEach(function (item) {
            item.paid_at = !item.paid_at && new Date().toFormat('YYYY-MM-DD')
          })
        } else {
          this.tempDetails = []
        }

        this.isSearching = false
      } catch (error) {
        console.log('ArchiveBulkPaymentsModal:listBillingList:catch(error): ', error)
        this.$toastr.error(this.translations('deposit.notice_failed'), this.translations('common.error'))
      }
    },

    updateBilling () {
      let list = []
      let self = this
      let noPaid = false
      let noPaidAt = false
      this.tempDetails.forEach(function (item) {
        if (item.isChecked) {
          if (!item.paid) {
            noPaid = true
          }
          if (!item.paid_at) {
            noPaidAt = true
          }
          list.push({
            billing_id: item.id,
            paid_at: item.paid_at,
            transfer_fee: item.transfer_fee,
            paid: item.paid
          })
        }
      })
      if (noPaid) {
        self.$toastr.error(this.translations('deposit.notice_enter_deposit_amount'), this.translations('common.error'))
        return
      }
      if (noPaidAt) {
        self.$toastr.error(this.translations('deposit.notice_enter_deposit_date'), this.translations('common.error'))
        return
      }

      if (list.length === 0) {
        this.$toastr.error(this.translations('deposit.notice_select_target_item'), this.translations('common.error'))
        return
      }

      if (list.length > 0) {
        this.isSearching = true

        try {
          let params = {
            list: list
          }

          this.$http.post(this.$api_url.bulk_add_from_billing, params).then(result => {
            if (result.data && result.data.status === true) {
              this.$toastr.success(this.translations('deposit.notice_lump_sum_payment_success'), this.translations('common.success'))
              this.$refs.closeModal.click()
              this.$emit('paid')
            } else {
              this.$toastr.error(result.data.message, this.translations('common.error'))
            }
            this.isSearching = false
          })
        } catch (error) {
          console.log('error: ', error)
          this.$toastr.error(this.translations('deposit.notice_error_occurred'), this.translations('common.error'))
          this.isSearching = false
        }
      }
    }
  }
}
</script>
